<template>
  <div class="body-container order-page" :class="{'big-list':!(activeIndex==0||activeIndex==2)}">
    <div class="head-box">
      <van-tabs v-model="activeIndex" @change='tabClick' class="list-tabs small">
        <van-tab title="全部" :name="0"></van-tab>
        <van-tab title="未支付" :name="-1"></van-tab>
        <van-tab title="已支付" :name="1"></van-tab>
        <van-tab title="已退保" :name="3"></van-tab>
        <van-tab title="已终止" :name="4"></van-tab>
      </van-tabs>
    </div>
    <ul class="child-type" v-if="activeIndex==-1&&(listLoading||list.length||typeId)">
      <li v-for="(item,i) in typeList2" :key="i" :class="{'active':typeId==item.id}" @click="clickTypeLevel2(item.id)">{{item.name}}</li>
    </ul>
    <orderList ref="list" :pageFlag="orderOrPolicy" @init="init" :isOrder="activeIndex==-1" @setListParams="setListParams" @listCallback="listCallback"></orderList>
  </div>
</template>

<script>
import orderList from "@/components/order/list";
import {pageTools,common} from "@/api/mixins";
export default {
  mixins:[pageTools,common],
  components:{orderList},
  data() {
    return {
      orderOrPolicy:'orderOrPolicy',
      listLoading:false,
      typeId:"1",
      typeList2:[
        {id:'1',name:"全部",orderStatus:"1,4,5,6,7,8,-9,10,-3",status:1 },
        {id:'2',name:"待支付",orderStatus:"1,-9",status:1,secondTab:1},
        {id:'3',name:"人核中",orderStatus:"7",status:1,secondTab:2},
        {id:'4',name:"核保失败",orderStatus:"4",status:1,secondTab:3},
        {id:'5',name:"已撤单",orderStatus:"8",status:1,secondTab:4},
        {id:'6',name:"待质检",orderStatus:"1,4,7,-9,10",status:1,secondTab:5},
      ],
      showSelectPanel:false,//账户类型弹窗
      type:"1",
      typeName:"全部账户",
      name: "",//投/被人姓名
      startTime:"",
      endTime:"",
      incomes:"",//服务费
      totalFee:"",//保费
      ordersNum:"",//订单数
      activeIndex: 0,
      list:[],
    };
  },
  created(){
  },
  mounted() {
    if(!this.checkLogin()){
      return;
    }
    if(sessionStorage.bdgjOrderTab) {
      this.activeIndex = sessionStorage.bdgjOrderTab*1;
    }
    if(sessionStorage.bdgjOrderTab2) {
      this.typeId = sessionStorage.bdgjOrderTab2
    }
    let activeIndex=this.$route.query.activeIndex
    if(activeIndex){
      this.activeIndex=activeIndex*1
    }
    // 查询订单列表
    this.$weixin.hideMenu();
    this.init()
  },
  methods: {
    init(){
      // 初始化列表
      this.$refs.list.init();
    },
    listCallback(res){
      this.listLoading = false;
      this.list = res.data;
    },
    //设置产品参数
    setListParams(params){
      this.listLoading = true;
      if(this.activeIndex==-1||this.activeIndex==1||this.activeIndex==0){//待支付或已支付或全部
        this.$refs.list.listUrl = "/api/getMyOrder";
      }else{
        this.$refs.list.listUrl = "/api/getMyPolicy";
      }
      
      if(this.activeIndex==-1){
        const secondType = this.typeList2.find(item=>item.id==this.typeId);
        // 凤栖参数
        params.orderStatus = secondType.orderStatus;
        params.payStatus = 0;
        // 保险中介云参数
        params.secondTab = secondType.secondTab;
        params.status = secondType.status;
      }else if(this.activeIndex==1){
        // 凤栖参数
        params.orderStatus = '2,7,9';
        params.payStatus = 1;
        // 保险中介云参数
        params.status = 2;
      }else{
        // 重置未支付二级菜单为选中全部
        this.typeId="1"
        if(this.activeIndex!=0){
          params.policyStatus = this.activeIndex;
        }
      }
      if(this.typeId == '5'){//质检
        params.isDoubleRecord = true;
      }
      return params
    },
    // 列表跳转
    goPage(url, params, e) {
      if(e.target.className.indexOf("copy") != -1){
        return;
      }
      this.$router.push({
        path: url,
        query: params
      });
    },
    tabClick(){
      // console.log(this.activeIndex)
      sessionStorage.bdgjOrderTab = this.activeIndex;
      this.list = [];
      this.$refs.list.searchAjax();
    },
    clickTypeLevel2(id){
      this.listLoading = true;
      this.typeId = id;
      sessionStorage.bdgjOrderTab2 = id;
      this.$refs.list.searchAjax();
    }
  },

};
</script>

<style lang="scss" scoped>
@import "./list";
</style>
